import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { isValidNameWithSpace, renderCheckBox, renderTextField } from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import { saveUserRoles, getUserRoleDetails } from '../actions/UserRoleActions';
import validate from '../validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../modules/AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import { displayCustomError } from '../../../../../../src/actions/utilAction';
import SmallLoader from '../../../../../img/small-loader.gif';

class UserRoleModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      userRoleId: props.userRoleId,
    };
  }

  componentWillMount() {
    if (this.state.userRoleId) {
      this.props.getUserRoleDetails(this.state.userRoleId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };
  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }
  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.userRoleId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  onSubmitHandler(formData) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formData.roleName = formData.roleName.trim();
    formData.userType = formData.RoleID === undefined || formData.RoleID < 1 ? 'STAFF' : formData.userType;
    formData.isActive = formData.isActive ? true : false;
    formData.isAdmin = formData.isAdmin ? true : false;    
    // console.log('formData.........inner.......',formData)
    this.props.clearFieldErrorArray();
    this.props.saveUserRoles(formData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.state.userRoleId ? 'Edit User Role' : 'Add User Role'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="roleName"
                    type="text"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Role name')}
                    customError={displayCustomError('ROLENAME', this.props.fieldError)}
                    maxLength="50"
                    label="Role Name"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />

                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <Field className="mt20 mb0"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
                <div className="col-sm-9 custm_appointmenttype">
                  <span>(Please make sure there are no users assigned to this role before making it inactive. Users will not be displayed if they do not have an active role.)</span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <Field className="mt20 mb0"
                    name="isAdmin"
                    label="Is Admin"
                    component={renderCheckBox}
                  />
                </div>
                <div className="col-sm-9">              
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}
function mapStateToProps(state, ownProps) {
  let initialValueData = {
    isActive: true,
  };

  if (ownProps.userRoleId && state.userRoles.userRoleDetails) {
    initialValueData = state.userRoles.userRoleDetails.data || null;
  }
  return {
    loading: state.userRoles.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  };
}

UserRoleModal = reduxForm({
  form: 'UserRoleModalForm',
  validate,
  enableReinitialize: true,
})(UserRoleModal);

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveUserRoles, getUserRoleDetails })(UserRoleModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/userRoles/components/UserRole_Modal.js